import { Component, OnInit, Optional, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../../core/service/common-service/common.service";
import { MatDialog, MatSort, MatPaginator, MatTableDataSource, MatDialogRef, MatTabChangeEvent } from "@angular/material";
import { Router } from "@angular/router";
import { DatePipe,Location } from "@angular/common";
import { openvisitReportDialog, VisitReportComponent } from "src/app/modal/visit-report/visit-report.component";
import { filter } from "rxjs/operators";
import { CallParams } from "src/app/model/call-params.model";
import { DialogService } from "src/app/dialog.service";

@Component({
  selector: 'app-lost-customer360',
  templateUrl: './lost-customer360.component.html',
  styleUrls: ['./lost-customer360.component.scss']
})
export class LostCustomer360Component implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('CallLogsPaginator', { static: true }) callLogsPaginator: MatPaginator;
  @ViewChild('CallLogsSort', { static: true }) callLogsSort: MatSort;
  @ViewChild('RemarksPaginator', { static: true }) remarksPaginator: MatPaginator;
  @ViewChild('RemarksSort', { static: true }) remarksSort: MatSort;
  @ViewChild('ServiceHistoryPaginator', { static: true }) serviceHistoryPaginator: MatPaginator;
  @ViewChild('ServiceHistorySort', { static: true }) serviceHistorySort: MatSort;

  cus360: any;
  cusType: string;
  calledNo: string;
  vehicleDetails: any = {};
  lastServiceDetails: any = {};
  // serviceDetails: any = {};
  spinner: boolean;
  vinNoList: string[] = [];
  vehicleInfoList: any[] = [];
  selectedNumber: any;
  selectedName: any;
  updatedNumber: any;
  updatedName: any;
  contactInfoOwner: any[] = [];
  contactInfoFleet: any[] = [];
  contactInfoDriver: any[] = [];
  updatedNumberType: string;
  secondaryNo: string;
  unableEdit: any = {};
  unableCall: boolean = false;
  workShops = <any>[];
  selectedWorkShop: string;
  audioSource: any = {};
  selectedVehicle: string;
  HideServiceHistory: boolean = true;
  historyToggleStatus: boolean = false;
  showCallDailog: boolean = false;
  showRecordingDailog: boolean = false;
  showPlayBtn: boolean = true;
  // paused: boolean = false;
  ownerSelected: boolean = true;
  fleetSelected: boolean = false;
  driverSelected: boolean = false;
  errorShow: any = {};
  customerID: string;
  userId: string;
  chassisNo: string;
  recentNumber: string;
  bookingCount: number;
  followupCount: number;
  customerData: any;
  vin: string;
  division: string;
  workshopAppointmentFlag: boolean = false;
  cdmTrailCheckOwner: boolean = false;
  cdmTrailCheckfleet: boolean = false;
  cdmTrailCheckdriver: boolean = false;
  secondTrailCall: boolean = false;
  dataSource1: any[];
  callLists: any;
  callCount: number = 0;
  remarksDetails: any;
  historyDetails: any;
  remarksCount: number = 0;
  historyCount: number = 0;
  private audio: HTMLMediaElement;
  selectedTab: any;
  custNameForSave: any;
  callOption: string;
  clicked: boolean = true;
  visitReportCheck: boolean = true;

  //service history table columns
  displayedColumns: string[] = [
    "jcNo",
    "servNo",
    "dealerLoc",
    "jbcardDate",
    "mileage",
    "failureDate",
    "billDate",
    "insdate",
    "mechanic",
    "serviceAdv",
    "serviceAdvNo"
  ];

  //call log table columns
  displayedCallColumns: string[] = [
    "number",
    "callDate",
    "startTime",
    "duration",
    "recording"
  ];

  //call log table columns
  displayedRemarksColumns: string[] = [
    "remark",
    "remarkDate",
    "remarkTime"
  ];
  customerInfo: any;

  constructor(
    private dialogService: DialogService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private commonService: CommonService,
    private toastr: ToastrService,
    private router: Router,
    private location:Location,
     ) {
    this.unableEdit['O'] = {};
    this.unableEdit['F'] = {};
    this.unableEdit['D'] = {};
      }

  ngOnInit() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || null)[0];
    this.customerData = JSON.parse(localStorage.getItem("customerData") || null);
    // this.callVisible = true;
    this.chassisNo = localStorage.getItem("chassisNo");
    this.userId = localStorage.getItem("userId");
    this.customerID = localStorage.getItem("customerId");
    this.workShops = JSON.parse(localStorage.getItem('workshops'));
    this.selectedWorkShop = (this.workShops && this.workShops.length) ? this.workShops[0].workshopCode : '';
    this.customerData = JSON.parse(localStorage.getItem("customerData"));
    this.vin = this.customerData.vin;
    if (localStorage.getItem("userId") == null || localStorage.getItem("userId") == undefined) {
      this.router.navigate(["login"]);
   }

    //this.getBookingFollowupCount(this.customerID, this.vin);
    this.getWorkshopAppointmentFlag();
    this.getCustomer360();
    this.getCallList();
    this.getContactdetail();
    this.showCustomerProfile();
    if(this.customerData.callTypeCode == 5){
    this.checkVisitReportStatus();
    }
  }

  /**
 * Name: getCallRecording
 * purpose: To get call recording and play
 */
  recordingUrl:string = ''
  getCallRecording(bucketName: string, fileName: string, id: string, source: string,element:any): void {
    console.log(element);
    

    if (element.recordingUrl) {
      this.recordingUrl = element.recordingUrl;
    }else{
      this.recordingUrl = '';
    }
    this.spinner = true;
    this.onRecordingClose();
    this.commonService.downloadAudio(bucketName, fileName, source).subscribe(res => {
      this.spinner = false;
      var binary = res['body'];
      var blob = new Blob([binary], { type: 'audio/mp4' });
      this.audioSource.id = id;
      this.audioSource.url = URL.createObjectURL(blob);
      if (this.audioSource.url) {
        this.playRecording();
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }
  /**
   * Name: playRecording
   * purpose: To play recoding
   */
  playRecording(): void {
    this.showPlayBtn = false;
    this.showRecordingDailog = true;
  }

  /**
   * Name: onRecordingClose
   * purpose: To close Recording dailog
   */
  onRecordingClose() {
    this.showPlayBtn = true;
    this.showRecordingDailog = false;
  }

  /**
  * Name: getContactdetail
  * purpose: To get customer Contact detail
  */
  getContactdetail(): void {
    this.spinner = true;
    this.commonService.contactdetail(this.customerID).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.contactInfoOwner = res["responseData"].filter(contact => contact.flag == "O");
        this.contactInfoFleet = res["responseData"].filter(contact => contact.flag == "F");
        this.contactInfoDriver = res["responseData"].filter(contact => contact.flag == "D");
        this.selectedNumber = this.contactInfoOwner[0].contactNo;
        this.selectedName = this.contactInfoOwner[0].name;
        this.unableEdit['O'][0] = true;
        this.unableEdit['O'][1] = false;
        this.unableEdit['D'][0] = true;
        this.unableEdit['D'][1] = false;
        this.updatedNumberType = 'Primary';
        this.unableCall = true;
        this.spinner = false;
      } else {
        this.spinner = false;
      }
    }, (err) => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    },
    ()=>{
      this.updateActiveContactNo();
    });
  }

  getCdmData() {
    let temp: any;
    this.selectedTab = this.selectedTab ? this.selectedTab : 0;

    let data = {
      "customerId": this.customerID,
      "vin": "",
      "phoneNo": "",
      "startDate": "",
      "endDate": "",
      "date": "",
      "customerName": "",
      "type": "T",
      "flag": this.selectedTab == 0 ? 'C' : this.selectedTab == 1 ? 'F' : this.selectedTab == 2 ? 'D' : 'C'
    };
    this.commonService.fetchCdmData(data).subscribe((resp) => {
      if (resp['responseCode'] == 0) {
        temp = resp["responseData"].filter(contact => contact.contactNo = contact.phoneNo);
        temp.forEach((trail) => {
          if (this.selectedTab == 0) {
            this.contactInfoOwner.push(trail)
            this.cdmTrailCheckOwner = true
          } else if (this.selectedTab == 1) {
            this.contactInfoFleet.push(trail)
            this.cdmTrailCheckfleet = true
          } else if (this.selectedTab == 2) {
            this.contactInfoDriver.push(trail)
            this.cdmTrailCheckdriver = true
          }
        })
        this.trailLogCheck();
      } else {
        this.toastr.error(resp['message'], "Error");
      }

    }, error => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
      });
    // this.contactInfoOwner.push(temp[0]);

  }

  trailLogCheck() {
    if (this.selectedTab == 0) {
      this.secondTrailCall = this.cdmTrailCheckOwner
      // return this.cdmTrailCheckOwner
    } else if (this.selectedTab == 1) {
      this.secondTrailCall = this.cdmTrailCheckfleet
      // return this.cdmTrailCheckfleet
    } else if (this.selectedTab == 2) {
      this.secondTrailCall = this.cdmTrailCheckdriver
      // return this.cdmTrailCheckdriver
    } else {
      this.secondTrailCall = false
    }
  }

  /**
  * Name: checkCallStatus
  * purpose: To set contect type selection
  * @param {any} type - type of number
  */
  checkCallStatus(type: any): void {
    this.onTabChange(type)
    this.selectedTab = type && type.index;
    if (type && type.index == 0) {
      this.ownerSelected = true;
      this.fleetSelected = false;
      this.driverSelected = false;
      if (this.contactInfoOwner.length) {
        this.unableCall = true;
        this.contactInfoOwner.forEach((element, i) => {
          if (this.unableEdit['O'][i] != undefined && this.unableEdit['O'][i]) {
            this.selectedNumber = element.contactNo;
            this.selectedName = element.name;
          }
        });
      } else {
        this.unableCall = false;
      }
    }

    if (type && type.index == 1) {
      this.ownerSelected = false;
      this.fleetSelected = true;
      this.driverSelected = false;
      if (this.contactInfoFleet.length) {
        this.unableCall = true;
        let numberSelected = false;
        this.contactInfoFleet.forEach((element, i) => {
          if (this.unableEdit['F'][i] != undefined && this.unableEdit['F'][i]) {
            this.selectedNumber = element.contactNo;
            this.selectedName = element.name;
            numberSelected = true;
          }
        });
        if (!numberSelected) {
          this.selectedNumber = this.contactInfoFleet[0].contactNo;
          this.selectedName = this.contactInfoFleet[0].name;
          this.unableEdit['F'][0] = true;
        }
      } else {
        this.unableCall = false;
      }
    }

    if (type && type.index == 2) {
      this.ownerSelected = false;
      this.fleetSelected = false;
      this.driverSelected = true;
      if (this.contactInfoDriver.length) {
        this.unableCall = true;
        let numberSelected = false;
        this.contactInfoDriver.forEach((element, i) => {
          if (this.unableEdit['D'][i] != undefined && this.unableEdit['D'][i]) {
            this.selectedNumber = element.contactNo;
            this.selectedName = element.name;
            numberSelected = true;
          }
        });
        if (!numberSelected) {
          this.selectedNumber = this.contactInfoDriver[0].contactNo;
          this.selectedName = this.contactInfoDriver[0].name;
          this.unableEdit['D'][0] = true;
        }
      } else {
        this.unableCall = false;
      }
    }
    this.trailLogCheck();
  }

  /**
   * Name: callUser
   * purpose: To call user
   */
  private callUser(): void {
    this.showRecordingDailog = false;
    this.spinner = true;
    let callNumber = "+91" + this.selectedNumber;
    let type = (this.ownerSelected ? 'C' : (this.fleetSelected ? 'F' : 'D'));
    if(type=='C'){
      this.contactInfoOwner.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
        }
      });
    }else if(type=='F'){
      this.contactInfoFleet.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
        }
      });
    }
    else if(type=='D'){
      this.contactInfoDriver.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
        }
      });
    }
    this.calledNo = this.selectedNumber;
    this.cusType = type;

    this.commonService.callCustomer(this.userId, this.customerID, callNumber, type, 'LCRM').subscribe(res => {
      if (res["responseCode"] == 0) {
        this.showCallDailog = true;
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });


    if (localStorage.getItem('countryCode')=='IND91') {
      this.callingToUser();
     }else{
      localStorage.setItem("exotel_URI",'')
     }
  }

  showVistResponse(): void {
    this.showRecordingDailog = false;
    // this.spinner = true;
    let callNumber = "+91" + this.selectedNumber;
    let type = (this.ownerSelected ? 'C' : (this.fleetSelected ? 'F' : 'D'));
    if(type=='C'){
      this.contactInfoOwner.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
        }
      });
    }else if(type=='F'){
      this.contactInfoFleet.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
        }
      });
    }
    else if(type=='D'){
      this.contactInfoDriver.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
        }
      });
    }
    this.calledNo = this.selectedNumber;
    this.cusType = type;
    this.showCallDailog = true;
  }

  /**
   * Name: onClose
   * purpose: To close call dailog
   */
  onClose() {
    this.showCallDailog = false;
    this.getContactdetail();
  }

  /**
   * Name: updateNumber
   * @param {boolean} addNumber - type of number
   * purpose: To set customer number
   */
  updateNumber(addNumber): void {
    // if ((this.updatedNumber && this.updatedNumber.length == 10) || (addNumber && this.secondaryNo && this.secondaryNo.length == 10)) {
      this.spinner = true;
      let oldNumber = this.selectedNumber;
      let newNumber = this.updatedNumber ? this.updatedNumber : this.selectedNumber;
      let oldName = this.selectedName;
      let newName = this.updatedName;
      if (addNumber) {
        oldNumber = this.secondaryNo;
        newNumber = this.secondaryNo;
        this.updatedNumberType = "Secondary";
      }
      this.commonService.updateNumber(newNumber, oldNumber, this.updatedNumberType, this.customerID, this.userId, oldName, newName).subscribe(res => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.selectedNumber = this.updatedNumber;
          this.selectedName = this.updatedName;
          this.toastr.success("Data is saved.", "Success");
          //this.getContactdetail();
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      })
    // }
  }

  getOption(){
    this.callOption=localStorage.getItem('navOption');
    return this.callOption;
  }

  onNameChange(name: any, editName: boolean, index: any, type: string) {
    if (type == 'D' && editName) {
      this.updatedName = name.name;
      this.updatedNumber = name.contactNo;
      this.updatedNumberType = 'D';
      this.errorShow[index] = false;
    } else {
      this.selectedName = name.name;
      this.updatedNumber = name.contactNo;
      this.updatedName = name.name;
      this.updatedNumberType = index == 0 ? 'Y' : "N";
      if (type == 'D') {
        this.contactInfoDriver.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      }
    }
  }

  /**
   * Name: onNumberChange
   * purpose: To get new selected number
   */
  onNumberChange(number: any, editNumber: boolean, index: any, type: string): void {
    if (type == "D" && editNumber && number.contactNo.length == 10) {
      this.updatedNumber = number.contactNo;
      this.updatedName = number.name;
      this.updatedNumberType = 'D';
      this.errorShow[index] = false;
    } else if (editNumber && number.contactNo.length == 10) {
      this.updatedNumber = number.contactNo;
      this.updatedName = number.name;
      this.updatedNumberType = index == 0 ? 'Y' : 'N';
      this.errorShow[index] = false;
    } else if (editNumber && number.contactNo.length !== 10) {
      this.errorShow[index] = true;
    } else {
      this.selectedNumber = number.contactNo;
      this.selectedName = number.name;
      this.updatedNumber = number.contactNo;
      this.updatedName = number.name;
      this.updatedNumberType = index == 0 ? 'Y' : 'N';
      if (type == 'O') {
        this.contactInfoOwner.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      } else if (type == 'F') {
        this.contactInfoFleet.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      } else if (type == 'D') {
        this.contactInfoDriver.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      }

    }
  }

  /**
   * Name: sendWorkshopMsg
   * purpose: To send workshop addess SMS
   */
  sendWorkshopMsg(): void {
    this.spinner = true;
    let data = {
      contactNo: this.selectedNumber,
      custName: this.cus360['CUSTOMER_INFO'].custName,
    }
    this.workShops.forEach(workshop => {
      if (workshop.workshopCode == this.selectedWorkShop) {
        data['wSAddress'] = workshop.workshopAddress || '';
        data['wSManager'] = workshop.contactNo || '';
        data['wSName'] = workshop.workshopName || '';
      }
    });
    this.commonService.sendLocationSMS(data).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
   * Name: getCustomer360
   * purpose: To get customer data
   */
  getCustomer360(): void {
    this.spinner = true;
    this.commonService.getLostcustomerdata(this.customerID, this.userId, this.vin).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.cus360 = res["responseData"];
        if (this.cus360["VECHILE_INFO"] && this.cus360["VECHILE_INFO"].length && this.cus360["VECHILE_INFO"][0].vin6Bits) {
          this.selectedVehicle = this.cus360["VECHILE_INFO"][0].vin6Bits
          this.cus360["VECHILE_INFO"].forEach(element => {
            this.vinNoList.push(element.vin6Bits);
            this.vehicleInfoList.push(element);
          });
          this.subTabDefault(this.selectedVehicle);
        } else {
          this.vehicleDetails = {};
        }
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
 * Name: getCallList
 * purpose: To get customer call data
 */
  getCallList(): void {
    this.spinner = true;
    this.commonService.callDetails(this.userId, this.customerID, 'LCRM').subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
 
        this.callLists = new MatTableDataSource(res['responseData']);
        this.recentNumber = (res['responseData'].length && res['responseData'][0].custNo) ? res['responseData'][0].custNo.split('+91')[1] : '';
        this.sort.direction = '';
        this.callLists.sort = this.callLogsSort;
        this.callLists.paginator = this.callLogsPaginator;
        this.callCount = res['responseData'].length;
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
   * Name: getHistory
   * purpose: To get service history
   */
  getHistory(showHistory: boolean): void {
    if (showHistory) {
      this.spinner = true;
      this.commonService.history(this.chassisNo).subscribe(
        res => {
          if (res["responseCode"] == 0) {
            this.HideServiceHistory = false;
            this.dataSource1 = res["responseData"];
            this.historyDetails = new MatTableDataSource(this.dataSource1);
            this.sort.direction = '';
            this.historyDetails.sort = this.serviceHistorySort;
            this.historyDetails.paginator = this.serviceHistoryPaginator;
            this.historyCount = this.dataSource1.length;
            this.spinner = false;
          } else {
            this.toastr.info(res["message"]);
            this.historyDetails = [];
            this.spinner = false;
            this.historyToggleStatus = false;
          }
        }, err => {
          this.spinner = false;
          this.historyToggleStatus = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    } else {
      this.HideServiceHistory = true;
    }
  }

  /**
   * Name: subTabDefault
   * purpose: To set vehicle details as selected
   */
  subTabDefault(selectedVehicle: string): void {
    this.vehicleDetails = this.cus360["VECHILE_INFO"].filter(vehicle => vehicle.vin6Bits == selectedVehicle)[0];
    this.division = this.vehicleDetails.division;
    localStorage.setItem("chassisNo", this.vehicleDetails.chassisNo);
    this.chassisNo = this.vehicleDetails.chassisNo;
    //change the sale date format
    this.vehicleDetails.saleDate = this.datePipe.transform(
      this.vehicleDetails.saleDate,
      "yyyy-MM-dd"
    );
    //set booking nd followup count
    if(this.cus360["BOOKING_FOLLOWUP_COUNT"] && Object.keys(this.cus360["BOOKING_FOLLOWUP_COUNT"]).length&& this.cus360["BOOKING_FOLLOWUP_COUNT"][selectedVehicle].length) {
      this.bookingCount = this.cus360["BOOKING_FOLLOWUP_COUNT"][selectedVehicle][0].bookingCount || 0;
      this.followupCount = this.cus360["BOOKING_FOLLOWUP_COUNT"][selectedVehicle][0].followUpCount || 0;
    } else {
      this.bookingCount = 0;
      this.followupCount = 0;
    }

    if (this.cus360["LAST_SERVICE_INFO"] && Object.keys(this.cus360["LAST_SERVICE_INFO"]).length && this.cus360["LAST_SERVICE_INFO"][selectedVehicle]) {
      this.lastServiceDetails = this.cus360["LAST_SERVICE_INFO"][selectedVehicle];
      localStorage.setItem("milage", this.lastServiceDetails.milage);
      this.lastServiceDetails.invoiceDate = this.datePipe.transform(
        this.lastServiceDetails.invoiceDate,
        "yyyy-MM-dd"
      );
    } else {
      this.lastServiceDetails = {};
    }

    if (this.cus360["LOST_CUSTOMER_REMARK_INFO"] && Object.keys(this.cus360["LOST_CUSTOMER_REMARK_INFO"]).length && this.cus360["LOST_CUSTOMER_REMARK_INFO"][selectedVehicle]) {
      let remarks = this.cus360["LOST_CUSTOMER_REMARK_INFO"][selectedVehicle];
      remarks.forEach(element => {
        let date = element.remarkTime + " GMT+0000";
        let d = new Date(date);
        element.remarkTime = d;
        element.remarkDate = this.datePipe.transform(element.remarkTime, "yyyy-MM-dd");
      });
      this.remarksDetails = new MatTableDataSource(remarks);
      this.sort.direction = '';
      this.remarksDetails.sort = this.remarksSort;
      this.remarksDetails.paginator = this.remarksPaginator;
      this.remarksCount = remarks.length;
    } else {
      this.remarksDetails = [];
    }
}

  getWorkshopAppointmentFlag(){
    this.commonService.getWorkshopAppointmentFlag(this.selectedWorkShop)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.workshopAppointmentFlag = res['responseData'][0].appointmentFlag;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  showVistReportFormfn() {
    if(this.visitReportCheck == false){
      this.toastr.error("Report already exist");
    }else{
      openvisitReportDialog(this.dialog).subscribe(val => {
        if(val=="false") {
          this.clicked=val
        }
      });
    }
  }

  showCustomerProfile(){
    this.commonService.getCustomerProfile(this.customerID).subscribe(res=>{

      if (res["responseCode"] == 0) {
        this.customerInfo = res["responseData"];

      } else {
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  checkVisitReportStatus(){
    this.commonService.LostCustomerVisitReportCheck(this.customerID, this.vin, this.userId).subscribe(res=>{
      if(res['responseCode'] == 0){
        if(res['responseData'] == 'Visit report already exist'){
          this.visitReportCheck = false;
          this.clicked = false;
        }
        else{
          this.clicked = true;
        }
      }
      else{
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    })
  }


  activeTabLabel: string = 'Owner'; 
  activeIndex:number = 0
  userInfo: any;


  selectedContactNumbers = {
    'Owner': null,
    'Fleet Manager': null,
    'Driver': null
  };

  onTabChange(event: MatTabChangeEvent) {
    this.activeTabLabel = event.tab.textLabel;
    this.activeIndex = event.index;
    this.updateActiveContactNo();
  }

 

  private updateActiveContactNo() {
    let contactList;
    
    if (this.activeIndex === 0) {
      contactList = this.contactInfoOwner;
    } else if (this.activeIndex === 1) {
      contactList = this.contactInfoFleet;
    } else if (this.activeIndex === 2) {
      contactList = this.contactInfoDriver;
    }
    
    console.log(this.activeIndex);
    console.log(contactList);
    if (contactList && contactList.length > 0) {
      this.selectedContactNumbers[this.activeTabLabel] = this.selectedContactNumbers[this.activeTabLabel] || contactList[0].contactNo;
    }
    
  }
  onRadioChange(contactNo: string, tabLabel: string) {
    this.selectedContactNumbers[tabLabel] = contactNo;
   
    
  }


  private callingToUser(){
    let customerPhone = this.selectedContactNumbers[this.activeTabLabel];
    if(customerPhone){
      this.makeCall(customerPhone)
    }else{
      this.spinner = false;
      this.toastr.error("Customer Phone number can't be Empty while placing the call")
    }
  }

  
  private makeCall(customerPhone:string) {
    const callParams = new CallParams(this.userInfo.contactNo, customerPhone);
    this.spinner = true
    this.commonService.createCallConnection_API(callParams).subscribe({
      next: (response) => {
        if(response.responseData.Uri) {
          localStorage.setItem("exotel_URI",response.responseData.Uri)
        } else{
          localStorage.setItem("exotel_URI",'')
        }
        if (response.responseCode==0) {
          this.toastr.success("Call is in progress")
          
        }else{
          this.toastr.error(response.responseData)
        }
        
      },
      error:(error)=>{
        this.spinner = false
        this.toastr.error("Something went wrong");
        
      },
      complete:()=>{
        this.spinner = false
      }
    });
  }


  openConfirmation() {
    if (localStorage.getItem('countryCode')=='IND91') {
      this.dialogService.openConfirmDialog().subscribe(result => {
        if (result) {
          console.log(result);
          this.callUser();    
        } else {
          console.log(result);
        }
      });
    }else{
      this.callUser();
    }
   
  }
}
